import type { TOC } from '@ember/component/template-only';

import PrismIcon from '../icon.gts';

interface PrismTableButtonSortSignature {
  Args: {
    isAscending?: boolean;
    isSorted?: boolean;
  };
}

const PrismTableButtonSort = <template>
  <div
    class="prism-table-button-sort-wrapper"
    data-test-id="table-header-sort-indicator"
  >
    {{#if @isSorted}}
      {{#if @isAscending}}
        <PrismIcon @name="sort-asc" />
      {{else}}
        <PrismIcon @name="sort-desc" />
      {{/if}}
    {{else}}
      <PrismIcon @name="sort" />
    {{/if}}
  </div>
</template> satisfies TOC<PrismTableButtonSortSignature>;

export default PrismTableButtonSort;
